import { AvailablePaymentCurrency, formatSmartNarrowCurrencyFromCents } from "@simplyk/common";

import { useLocaleContext } from "@/contexts/LocaleContext";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedItemPriceProps = {
  price: number | null | undefined;
  formCurrency: AvailablePaymentCurrency;
};

export const ThemedItemPrice = ({ price, formCurrency }: ThemedItemPriceProps) => {
  const { t } = useTranslate();
  const { isoLocale } = useLocaleContext();

  const formatPriceDisplay = () => {
    // In preview mode, the amount can be undefined and we don't want to display a price or a free price
    if (price === null || price === undefined) {
      return "$ -";
    }
    if (price === 0) {
      return t("common", "free");
    }
    return formatSmartNarrowCurrencyFromCents(price, {
      locale: isoLocale,
      currency: formCurrency,
    });
  };

  return (
    <FormTypography vibe="brand" variant="h6" fontWeight={700} data-test="themed-item-price">
      {formatPriceDisplay()}
    </FormTypography>
  );
};
